import { cn } from '@exam-room/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef } from 'react';

const iconButtonVariants = cva('cursor-pointer rounded-sm p-2', {
  variants: {
    variant: {
      default: 'hover:bg-off-white',
      filled:
        'bg-primary text-text-primary hover:bg-off-white hover:text-primary-900 focus:text-primary-900',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

interface IconButtonProps
  extends React.ComponentProps<'button'>,
    VariantProps<typeof iconButtonVariants> {
  children: JSX.Element | string;
  className?: string;
}

function IconButtonBase(
  { variant, children, className = '', onClick, ...props }: IconButtonProps,
  ref: React.ForwardedRef<HTMLButtonElement>,
) {
  return (
    <button
      className={cn(iconButtonVariants({ variant }), className)}
      onClick={onClick}
      type='button'
      ref={ref}
      {...props}
    >
      {children}
    </button>
  );
}

const IconButton = forwardRef(IconButtonBase);

export default IconButton;
